import apiClient from "../../../utilities/apiClient";

export const departments = (payload) => {
  return apiClient.post(`${apiClient.Urls.departments}`, payload, true, "");
};

export const get_departments = (payload) => {
  return apiClient.get(`${apiClient.Urls.departments_list}`, payload, true);
};
